import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeMainComponent } from './components/home-main/home-main.component';
import { HomeReportComponent } from './components/home-report/home-report.component';

const routes: Routes = [
  {
    path: '',
    component: HomeMainComponent
  },
  {
    path: 'report',
    component: HomeReportComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class HomeRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/home/home-routing.module.ts